import { Component } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'app-skeleton-menu-item',
  standalone: true,
  imports: [NgxSkeletonLoaderModule],
  template: `
    <ngx-skeleton-loader
      count="8"
      appearance="line"
      [theme]="{
        'border-radius': '10px',
        height: '40px',
      }" />
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class SkeletonMenuItemComponent {}
